
import { supabase } from "@/integrations/supabase/client";
import type { Photo } from "@/types/supabase";

export const getPhotos = async () => {
  console.log("Fetching photos from database...");
  const { data, error } = await supabase
    .from('photos')
    .select('*')
    .order('created_at', { ascending: false });
    
  if (error) {
    console.error("Error fetching photos:", error);
    throw error;
  }
  console.log("Photos fetched successfully:", data?.length || 0, "photos");
  return data as Photo[];
};

export const uploadPhoto = async (file: File, title: string, category: string, featured: boolean) => {
  try {
    console.log("Starting photo upload process...");
    
    // 1. Générer un nom de fichier unique
    const fileExt = file.name.split('.').pop();
    const storagePath = `${crypto.randomUUID()}.${fileExt}`;
    
    console.log("Uploading file to storage:", storagePath);
    // 2. Télécharger l'image dans le bucket de stockage
    const { error: uploadError, data: storageData } = await supabase.storage
      .from('villa_photos')
      .upload(storagePath, file);
      
    if (uploadError) {
      console.error("Storage upload error:", uploadError);
      throw uploadError;
    }
    
    console.log("File uploaded successfully, adding database entry");
    // 3. Ajouter l'entrée dans la table photos
    const { data: photo, error: insertError } = await supabase
      .from('photos')
      .insert([
        {
          title,
          category,
          featured,
          storage_path: storagePath
        }
      ])
      .select()
      .single();
      
    if (insertError) {
      console.error("Database insert error:", insertError);
      // Si l'insertion échoue, supprimer le fichier précédemment téléchargé
      await supabase.storage.from('villa_photos').remove([storagePath]);
      throw insertError;
    }
    
    console.log("Photo upload complete:", photo);
    return photo as Photo;
  } catch (error) {
    console.error("Error uploading photo:", error);
    throw error;
  }
};

export const updatePhoto = async (id: string, updates: Partial<Photo>) => {
  console.log("Updating photo:", id, updates);
  const { data, error } = await supabase
    .from('photos')
    .update(updates)
    .eq('id', id)
    .select()
    .single();
    
  if (error) {
    console.error("Error updating photo:", error);
    throw error;
  }
  console.log("Photo updated successfully:", data);
  return data as Photo;
};

export const deletePhoto = async (id: string, storagePath: string) => {
  try {
    console.log("Deleting photo:", id, "with storage path:", storagePath);
    
    // Supprimer le fichier du stockage
    const { error: storageError } = await supabase.storage
      .from('villa_photos')
      .remove([storagePath]);
      
    if (storageError) {
      console.error("Error removing file from storage:", storageError);
      throw storageError;
    }
    
    // Supprimer l'entrée de la base de données
    const { error: dbError } = await supabase
      .from('photos')
      .delete()
      .eq('id', id);
      
    if (dbError) {
      console.error("Error deleting photo from database:", dbError);
      throw dbError;
    }
    
    console.log("Photo deleted successfully");
  } catch (error) {
    console.error("Error deleting photo:", error);
    throw error;
  }
};

export const getPhotoUrl = (storagePath: string) => {
  const url = supabase.storage
    .from('villa_photos')
    .getPublicUrl(storagePath)
    .data.publicUrl;
  
  return url;
};
